import TextField from "@mui/material/TextField";
import styled from "styled-components";
import { FormControl, InputLabel, Select, MenuItem, FormControlLabel } from "@mui/material";

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "3rem",
    "& fieldset": {
      borderColor: "white",
      borderRadius: "1.5rem",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
    "& input": {
      color: "white",
      padding: "0.75rem 1rem",
      boxSizing: "border-box",
    },
  },
  "& .MuiInputLabel-root": {
    color: "white",
    top: "-0.25rem",
  },
  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled": {
    color: "white",
  },
  "@media (max-width: 620px)": {
    width: "22rem", // Responsive width for smaller screens
    margin: "0 auto", // Center align
  },
});

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0;
  margin-bottom: 5rem;
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  gap: 15rem;
  @media (max-width: 1050px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 25rem;
  @media (max-width: 1050px) {
    width: 100%;
  }
  @media (max-width: 620px) {
    align-items: center;
  }
`;

export const StyledFormControl = styled(FormControl)({
  "& .MuiInputLabel-root": {
    color: "white",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "white",
  },
  "& .MuiOutlinedInput-root": {
    height: "3rem",
    "& fieldset": {
      borderColor: "white",
      borderRadius: "1.5rem",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
  "& .MuiSelect-icon": {
    color: "white",
  },
  "& .MuiSelect-select": {
    color: "white",
    padding: "0.75rem 1rem",
  },
  width: "25rem", // Default width for larger screens
  "@media (max-width: 620px)": {
    width: "22rem", // Responsive width for smaller screens
    margin: "0 auto", // Center align
  },
});

export const StyledSelect = styled(Select)({
  color: "white",
  borderRadius: "1.5rem",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
    borderRadius: "1.5rem",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "& .MuiSelect-icon": {
    color: "white",
  },
  width: "100%", // Full width within FormControl
  "@media (max-width: 620px)": {
    width: "22rem", // Responsive width for smaller screens
    margin: "0 auto", // Center align
  },
});


export const StyledInputLabel = styled(InputLabel)({
  color: "white",
  "&.Mui-focused": {
    color: "white",
  },
});

export const StyledMenuItem = styled(MenuItem)({
  color: "white",
  "&.Mui-focused": {
    color: "white",
  },
});

export const StyledMultilineTextField = styled(TextField)({
  width: "55%",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
      borderRadius: "1.5rem",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
    "& textarea": {
      color: "white",
      padding: "0.75rem 1rem",
      boxSizing: "border-box",
    },
  },
  "& .MuiInputLabel-root": {
    color: "white",
    top: "-0.25rem",
  },
  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled": {
    color: "white",
  },
  "@media (max-width: 1050px)": {
    width: "25rem",
  },
  "@media (max-width: 620px)": {
    width: "22rem",
  },
});

export const StyledFormControlLabel = styled(FormControlLabel)({
  "& .MuiTypography-root": {
    color: "white", 
  },
  "& .MuiCheckbox-root": {
    color: "white",
  },
  "& .MuiCheckbox-root.Mui-checked": {
    color: "white",
  },
  "@media (max-width: 1050px)": {
    width: "25rem",
  },
  "@media (max-width: 620px)": {
    width: "22rem",
    display: "flex",
    justifyContent: "center",
  },
});

export const HighlightLink = styled.span`
    font-weight: bold;
    text-decoration: none;
    transition: all 0.3s ease-in-out;

    &:hover {
      border-bottom: 2px solid white;
      text-decoration: none;
    }
`;